import { render } from "./FormTabs.vue?vue&type=template&id=6db4d9c7&scoped=true"
import script from "./FormTabs.vue?vue&type=script&lang=js"
export * from "./FormTabs.vue?vue&type=script&lang=js"

import "./FormTabs.vue?vue&type=style&index=0&id=6db4d9c7&scoped=true&lang=css"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db4d9c7"],['__file',"FormTabs.vue"]])

export default __exports__